type AppConstant = {
  [key: string]: any;
};

export const generalAppVariables: AppConstant = {
  INTERCOM_APP_ID: "zbjbzmql",
  INTERCOM_API_BASE: "https://api-iam.eu.intercom.io",
  G_CLIENT_ID: "670644075460-hj401h1r7s9hagkog7tc77un157deanq.apps.googleusercontent.com",
  DEFAULT_PROVIDER: "gcp",
  DEFAULT_REGION: "v3_GCP_US_CENTRAL1_GCP",
  BACKUPS_ENABLED: false,
  RETENTION_ENABLED: false,
  ADDITIONAL_FEATURES_ENABLED: false,
  DEFAULT_SIZE: "MAU_500_GCP",
  DEFAULT_RETENTION: "6months",
  DEFAULT_BACKUP: "daily",
  DEFAULT_PAYMENT_CYCLE: "month",
  DEFAULT_PLAN_MOCK_CLOUD: "v3.mau_500_gcp.base",
  DEFAULT_PLAN_GCP: "v3.mau_500_gcp.base",
  DEFAULT_PAID_PLAN: "v2.mau_1_000_gcp.base",
  DEFAULT_PAID_PLAN_GCP: "v3.mau_5_000_gcp.base",
  EXPERIMENTAL_PLAN_GCP: "v3.mau_500_gcp.base",
  EXPERIMENTAL_PAID_PLAN_GCP: "v3.mau_1_000_gcp.base",
  REFRESH_INTERVAL: 10000,
  // Single switch for the "v3-only" behaviour: when true, the server-creation
  // wizard shows only plans whose code starts with "v3" and non-v3 servers are
  // blocked from upgrading. When false, all plans are shown and upgrades are allowed.
  V3_PLAN_FILTER_ENABLED: true,
  // Plan codes that are hard-hidden from every plan list shown to users
  // (server-creation wizard + public price calculator), regardless of the
  // v3-only filter above. Single source of truth for these exclusions.
  HIDDEN_PLAN_CODES: [
    "v3.mau_500_gcp.base",
    "v3.mau_1_000_gcp.base",
    "v3.mau_2_000_gcp.base",
  ],
};

export const countlyVariables: AppConstant = {
  DEV_APP_KEY: "8d4d8be00d446223bada903ad718bc1cbd274125",
  PROD_APP_KEY: "6943953441884362ba30ac59047ceb7f3c7098f0",
  DEV_WS_APP_KEY: "1ab10d38ef50bdf1a4eae4e02aebd4b01f228984",
  PROD_WS_APP_KEY: "b4996044bfaeab230f5d2765e51a778c6d2f087e",
  DEV_LANDING_APP_KEY: "a00c023174edad117c415bdd0f3c627df02e7f48",
  PROD_LANDING_APP_KEY: "8ab5b99a3d881725717ae66c59313d581dfc7690",
  SERVER_URL: "https://stats.count.ly",
  DEBUG: false,
  NAMESPACE: "my-countly",
  REMOTE_CONFIG: true,
  REQUIRE_CONSENT: false,
  PADDLE_SELLER_DEV: 11725,
  PADDLE_SELLER_PROD: 169089,
  PADDLE_CLIENT_TOKEN_PROD: "live_e3bd9ffa7ca1db654f32d809e89",
  PADDLE_CLIENT_TOKEN_DEV: "test_ba0fe7fcb7f54bc104a1723882e",
};

export const contentVariables: AppConstant = {
  ANNOUNCEMENT_FALLBACK: {
    badge: 'New release',
    title: 'Countly 22.12 is now available',
    description: 'We are excited to announce the release of Countly 22.12. This release includes new features, improvements, and bug fixes. Check out the release notes to learn more.',
    hasVideo: true,
    hasImage: false,
    content: 'https://www.youtube.com/watch?v=9bZkp7q19f0',
  },
  CONTENT_PROVIDER_URL: "https://cms.count.ly",
  STRAPI_TOKEN:
    "33931935c8076cbb0ea3f00dcdcb6c58e0f8c97797feff1d0684ae6ec38d057638c1c755d4e0e8b6ffdeee602a06a47bafc45cc52b9185318e61f3f877a95f20cdee0af9d539e03d030a3ce102e4dc4325f625b40b7771224f68bed763578ff6a96e987199fb854cd8c9702f34e9bffa0ba2980eff0b5c99506a90199a6b5042",
  FEATURES_FALLBACK: [
    {
      id: 13,
      attributes: {
        featureID: "journey",
        createdAt: "2023-03-15T21:06:04.464Z",
        updatedAt: "2023-03-16T14:28:11.235Z",
        publishedAt: "2023-03-15T21:06:17.122Z",
        locale: "en",
        description:
          "Create custom popups and display them to users who execute specific actions during their app journeys.",
        name: "Journeys & Content Builder",
        arcadeEmbedURL: "https://demo.arcade.software/JQK0Nmdi0ARIgi0k7iKg?embed",
        icon: {
          data: {
            id: 5,
            attributes: {
              name: "voc.svg",
              alternativeText: null,
              caption: null,
              width: 96,
              height: 95,
              formats: null,
              hash: "voc_77375dfd68",
              ext: ".svg",
              mime: "image/svg+xml",
              size: 2.14,
              url: "/uploads/voc_77375dfd68.svg",
              previewUrl: null,
              provider: "local",
              provider_metadata: null,
              createdAt: "2023-03-16T14:27:50.496Z",
              updatedAt: "2023-03-16T14:27:50.496Z",
            },
          },
        },
        localizations: { data: [] },
      },
    },
    {
      id: 2,
      attributes: {
        featureID: "voice-customer",
        createdAt: "2023-03-15T21:06:04.464Z",
        updatedAt: "2023-03-16T14:28:11.235Z",
        publishedAt: "2023-03-15T21:06:17.122Z",
        locale: "en",
        description:
          "Collect feedback from the right users for a complete view of your user experience using surveys, NPS®, and ratings",
        name: "Voice of the Customer",
        arcadeEmbedURL: "https://demo.arcade.software/JQK0Nmdi0ARIgi0k7iKg?embed",
        icon: {
          data: {
            id: 5,
            attributes: {
              name: "voc.svg",
              alternativeText: null,
              caption: null,
              width: 96,
              height: 95,
              formats: null,
              hash: "voc_77375dfd68",
              ext: ".svg",
              mime: "image/svg+xml",
              size: 2.14,
              url: "/uploads/voc_77375dfd68.svg",
              previewUrl: null,
              provider: "local",
              provider_metadata: null,
              createdAt: "2023-03-16T14:27:50.496Z",
              updatedAt: "2023-03-16T14:27:50.496Z",
            },
          },
        },
        localizations: { data: [] },
      },
    },
    {
      id: 3,
      attributes: {
        featureID: "formulas",
        createdAt: "2023-03-15T21:08:50.993Z",
        updatedAt: "2023-03-16T14:28:26.004Z",
        publishedAt: "2023-03-15T21:16:28.223Z",
        locale: "en",
        description:
          "Craft formulas with your existing data in Countly to reveal insights about your users and their behavioural patterns, elevating your understanding of their needs",
        name: "Formulas",
        arcadeEmbedURL: "https://demo.arcade.software/F34ma7amWt4WCxs2rDD8?embed",
        icon: {
          data: {
            id: 7,
            attributes: {
              name: "formulas.svg",
              alternativeText: null,
              caption: null,
              width: 96,
              height: 95,
              formats: null,
              hash: "formulas_b7e283f857",
              ext: ".svg",
              mime: "image/svg+xml",
              size: 1.47,
              url: "/uploads/formulas_b7e283f857.svg",
              previewUrl: null,
              provider: "local",
              provider_metadata: null,
              createdAt: "2023-03-16T14:27:50.887Z",
              updatedAt: "2023-03-16T14:27:50.887Z",
            },
          },
        },
        localizations: { data: [] },
      },
    },
    {
      id: 4,
      attributes: {
        featureID: "hooks",
        createdAt: "2023-03-15T21:22:41.640Z",
        updatedAt: "2023-03-16T14:28:37.266Z",
        publishedAt: "2023-03-15T21:22:43.015Z",
        locale: "en",
        description:
          "Trigger external endpoints and receive emails based on incoming data and internal triggers, such as users entering a cohort",
        name: "Hooks",
        arcadeEmbedURL: "https://demo.arcade.software/q5idm0f8TBRTWnPEJFXj?embed",
        icon: {
          data: {
            id: 10,
            attributes: {
              name: "hooks.svg",
              alternativeText: null,
              caption: null,
              width: 96,
              height: 95,
              formats: null,
              hash: "hooks_a41901563c",
              ext: ".svg",
              mime: "image/svg+xml",
              size: 1.42,
              url: "/uploads/hooks_a41901563c.svg",
              previewUrl: null,
              provider: "local",
              provider_metadata: null,
              createdAt: "2023-03-16T14:27:51.047Z",
              updatedAt: "2023-03-16T14:27:51.047Z",
            },
          },
        },
        localizations: { data: [] },
      },
    },
    {
      id: 5,
      attributes: {
        featureID: "dbviewer",
        createdAt: "2023-03-16T14:30:23.528Z",
        updatedAt: "2023-03-16T14:35:59.756Z",
        publishedAt: "2023-03-16T14:35:59.749Z",
        locale: "en",
        description:
          "Retrieve your raw data directly from the dashboard or through the API, perform queries across all data collections, and export data from your Countly server in the desired format",
        name: "Database Viewer",
        arcadeEmbedURL: "https://demo.arcade.software/ILdZpaJWbmKMytCXOdMT?embed",
        icon: {
          data: {
            id: 8,
            attributes: {
              name: "db.svg",
              alternativeText: null,
              caption: null,
              width: 96,
              height: 95,
              formats: null,
              hash: "db_afb4c5f276",
              ext: ".svg",
              mime: "image/svg+xml",
              size: 1.41,
              url: "/uploads/db_afb4c5f276.svg",
              previewUrl: null,
              provider: "local",
              provider_metadata: null,
              createdAt: "2023-03-16T14:27:50.931Z",
              updatedAt: "2023-03-16T14:27:50.931Z",
            },
          },
        },
        localizations: { data: [] },
      },
    },
    {
      id: 6,
      attributes: {
        featureID: "crashes",
        createdAt: "2023-03-16T14:40:06.602Z",
        updatedAt: "2023-03-16T14:40:08.010Z",
        publishedAt: "2023-03-16T14:40:07.999Z",
        locale: "en",
        description:
          "Collect crash reports, error logs, and performance metrics from your applications, allowing you to address issues proactively before they affect your users' experience",
        name: "Crash and Performance Analytics",
        arcadeEmbedURL: null,
        icon: {
          data: {
            id: 4,
            attributes: {
              name: "crash.svg",
              alternativeText: null,
              caption: null,
              width: 96,
              height: 95,
              formats: null,
              hash: "crash_4a4172da32",
              ext: ".svg",
              mime: "image/svg+xml",
              size: 1.54,
              url: "/uploads/crash_4a4172da32.svg",
              previewUrl: null,
              provider: "local",
              provider_metadata: null,
              createdAt: "2023-03-16T14:27:50.493Z",
              updatedAt: "2023-03-16T14:27:50.493Z",
            },
          },
        },
        localizations: { data: [] },
      },
    },
    {
      id: 7,
      attributes: {
        featureID: "push",
        createdAt: "2023-03-16T14:43:30.172Z",
        updatedAt: "2023-03-16T14:43:31.400Z",
        publishedAt: "2023-03-16T14:43:31.394Z",
        locale: "en",
        description:
          "Deliver personalized one-time or automated push notifications to your mobile application users for enhanced engagement and communication",
        name: "Push Notifications",
        arcadeEmbedURL: "https://demo.arcade.software/smxfAs8hDGs7SC1eTRkh?embed",
        icon: {
          data: {
            id: 3,
            attributes: {
              name: "push.svg",
              alternativeText: null,
              caption: null,
              width: 96,
              height: 95,
              formats: null,
              hash: "push_bc40276791",
              ext: ".svg",
              mime: "image/svg+xml",
              size: 1.35,
              url: "/uploads/push_bc40276791.svg",
              previewUrl: null,
              provider: "local",
              provider_metadata: null,
              createdAt: "2023-03-16T14:27:50.489Z",
              updatedAt: "2023-03-16T14:27:50.489Z",
            },
          },
        },
        localizations: { data: [] },
      },
    },
    {
      id: 8,
      attributes: {
        featureID: "remote-ab",
        createdAt: "2023-03-16T15:34:18.952Z",
        updatedAt: "2023-03-16T15:34:21.367Z",
        publishedAt: "2023-03-16T15:34:21.358Z",
        locale: "en",
        description:
          "Adjust the appearance and functionality of your application remotely for specific user segments or all users, and run experiments to pinpoint the most effective improvements",
        name: "Remote Config and A/B Testing",
        arcadeEmbedURL: "https://demo.arcade.software/aQojAUcX8CVzZr58DS45?embed",
        icon: {
          data: {
            id: 6,
            attributes: {
              name: "remote.svg",
              alternativeText: null,
              caption: null,
              width: 96,
              height: 95,
              formats: null,
              hash: "remote_ec0cffbf98",
              ext: ".svg",
              mime: "image/svg+xml",
              size: 1.37,
              url: "/uploads/remote_ec0cffbf98.svg",
              previewUrl: null,
              provider: "local",
              provider_metadata: null,
              createdAt: "2023-03-16T14:27:50.873Z",
              updatedAt: "2023-03-16T14:27:50.873Z",
            },
          },
        },
        localizations: { data: [] },
      },
    },
    {
      id: 9,
      attributes: {
        featureID: "okta-ad",
        createdAt: "2023-03-20T13:10:22.518Z",
        updatedAt: "2023-03-20T13:25:13.360Z",
        publishedAt: "2023-03-20T13:25:13.354Z",
        locale: "en",
        description:
          "Authorize and authenticate your dashboard users using Okta or Microsoft/Azure Active Directory",
        name: "Okta or Active Directory Auth",
        arcadeEmbedURL: null,
        icon: {
          data: {
            id: 11,
            attributes: {
              name: "okta-ad.svg",
              alternativeText: null,
              caption: null,
              width: 96,
              height: 95,
              formats: null,
              hash: "okta_ad_c91b0e0dcc",
              ext: ".svg",
              mime: "image/svg+xml",
              size: 3.14,
              url: "/uploads/okta_ad_c91b0e0dcc.svg",
              previewUrl: null,
              provider: "local",
              provider_metadata: null,
              createdAt: "2023-03-20T13:10:16.495Z",
              updatedAt: "2023-03-20T13:10:16.495Z",
            },
          },
        },
        localizations: { data: [] },
      },
    },
  ],
  RESOURCES_FALLBACK: [
    {
      id: 1,
      attributes: {
        title: "Countly SDKs",
        createdAt: "2023-03-21T06:12:47.669Z",
        updatedAt: "2023-03-21T06:25:07.147Z",
        publishedAt: "2023-03-21T06:12:49.300Z",
        order: 1,
        columnWidth: 1,
        description:
          "Easily get started with Countly SDKs for web, mobile, desktop, and server platforms",
        linkURL:
          "https://support.count.ly/hc/en-us/articles/360037236571-Downloading-and-Installing-SDKs",
        linkText: "Find your SDK",
        icon: {
          data: {
            id: 21,
            attributes: {
              name: "resources-sdks.svg",
              alternativeText: null,
              caption: null,
              width: 28,
              height: 29,
              formats: null,
              hash: "resources_sdks_69bc07dd36",
              ext: ".svg",
              mime: "image/svg+xml",
              size: 36.91,
              url: "/uploads/resources_sdks_69bc07dd36.svg",
              previewUrl: null,
              provider: "local",
              provider_metadata: null,
              createdAt: "2023-03-21T06:25:02.637Z",
              updatedAt: "2023-03-21T06:25:02.637Z",
            },
          },
        },
      },
    },
    {
      id: 2,
      attributes: {
        title: "User Guides",
        createdAt: "2023-03-21T06:15:50.525Z",
        updatedAt: "2023-03-21T06:25:26.502Z",
        publishedAt: "2023-03-21T06:15:51.695Z",
        order: 2,
        columnWidth: 1,
        description: "Explore comprehensive user guides for all Countly Server features",
        linkURL:
          "https://support.count.ly/hc/en-us/sections/7039354168729-User-Guides-Countly-22-x",
        linkText: "View guides",
        icon: {
          data: {
            id: 20,
            attributes: {
              name: "resources-guides.svg",
              alternativeText: null,
              caption: null,
              width: 28,
              height: 29,
              formats: null,
              hash: "resources_guides_e69054c8bf",
              ext: ".svg",
              mime: "image/svg+xml",
              size: 24.07,
              url: "/uploads/resources_guides_e69054c8bf.svg",
              previewUrl: null,
              provider: "local",
              provider_metadata: null,
              createdAt: "2023-03-21T06:25:02.628Z",
              updatedAt: "2023-03-21T06:25:02.628Z",
            },
          },
        },
      },
    },
    {
      id: 3,
      attributes: {
        title: "Become a part of the Countly Community",
        createdAt: "2023-03-21T06:22:31.291Z",
        updatedAt: "2023-03-21T06:22:34.879Z",
        publishedAt: "2023-03-21T06:22:34.873Z",
        order: 3,
        columnWidth: 2,
        description:
          "Connect with fellow Countly users, ask questions, learn best practices, and engage with the Countly team",
        linkURL: "https://countly.com",
        linkText: "Join the community",
        icon: { data: null },
      },
    },
  ],
  CORE_FEATURES_FALLBACK: [
    {
      id: 1,
      attributes: {
        featureID: "funnels",
        createdAt: "2023-03-15T21:06:04.464Z",
        updatedAt: "2023-03-16T14:28:11.235Z",
        publishedAt: "2023-03-15T21:06:17.122Z",
        locale: "en",
        description:
          "Build step-by-step funnels to identify user conversion points and drop-offs, and use flows to visualize typical customer journeys",
        name: "Funnel and Flow Analysis",
        arcadeEmbedURL: "https://demo.arcade.software/JQK0Nmdi0ARIgi0k7iKg?embed",
        localizations: { data: [] },
      },
    },
    {
      id: 12,
      attributes: {
        featureID: "cohorts",
        createdAt: "2023-03-15T21:06:04.464Z",
        updatedAt: "2023-03-16T14:28:11.235Z",
        publishedAt: "2023-03-15T21:06:17.122Z",
        locale: "en",
        description:
          "Group users in real-time based on their attributes, activities, or inactivity, and leverage these cohorts for targeted campaigns, remote configurations, and in-depth analysis",
        name: "Behavioral User Cohorts",
        arcadeEmbedURL: "https://demo.arcade.software/JQK0Nmdi0ARIgi0k7iKg?embed",
        localizations: { data: [] },
      },
    },
    {
      id: 3,
      attributes: {
        featureID: "retention",
        createdAt: "2023-03-15T21:06:04.464Z",
        updatedAt: "2023-03-16T14:28:11.235Z",
        publishedAt: "2023-03-15T21:06:17.122Z",
        locale: "en",
        description:
          "Explore user retention based on session and event activity, and use filters and segmentation for deeper insights",
        name: "Retention Analysis",
        arcadeEmbedURL: "https://demo.arcade.software/JQK0Nmdi0ARIgi0k7iKg?embed",
        localizations: { data: [] },
      },
    },
    {
      id: 4,
      attributes: {
        name: "User Profiles",
        createdAt: "2023-03-20T10:04:18.533Z",
        updatedAt: "2023-03-20T14:58:30.469Z",
        publishedAt: "2023-03-20T10:04:37.639Z",
        description:
          "Dive deep into your data to examine individual user behavior, including their activities, funnel completion, performance issues, and the cohorts they belong to",
        order: 2,
      },
    },
    {
      id: 5,
      attributes: {
        name: "Event Tracking and Analytics",
        createdAt: "2023-03-20T10:04:48.728Z",
        updatedAt: "2023-03-20T14:58:40.008Z",
        publishedAt: "2023-03-20T10:04:49.674Z",
        description:
          "Track events to capture user actions, milestones, and transactions and include segmentation properties for in-depth analysis",
        order: 4,
      },
    },
    {
      id: 4,
      attributes: {
        name: "Advanced Data Segmentation",
        createdAt: "2023-03-20T10:05:08.184Z",
        updatedAt: "2023-03-20T14:58:45.779Z",
        publishedAt: "2023-03-20T10:05:09.147Z",
        description:
          "Use a visual query builder to filter and segment all your Countly data, then visualize it in various formats for better insights",
        order: 5,
      },
    },
    {
      id: 7,
      attributes: {
        name: "Dashboards",
        createdAt: "2023-03-20T10:05:49.524Z",
        updatedAt: "2023-03-20T14:59:00.633Z",
        publishedAt: "2023-03-20T10:05:50.454Z",
        description:
          "Create dashboards to display key metrics and visualizations, helping you and your team stay informed and aligned",
        order: 8,
      },
    },
    {
      id: 8,
      attributes: {
        name: "Revenue Analytics",
        createdAt: "2023-03-20T10:06:06.664Z",
        updatedAt: "2023-03-20T14:59:07.868Z",
        publishedAt: "2023-03-20T10:06:07.556Z",
        description:
          "Track and visualize revenue metrics including total revenue, revenue per user, and per paying user",
        order: 9,
      },
    },
    {
      id: 9,
      attributes: {
        name: "Email Reports and Alerts",
        createdAt: "2023-03-20T10:06:20.943Z",
        updatedAt: "2023-03-20T14:59:14.576Z",
        publishedAt: "2023-03-20T10:06:21.886Z",
        description:
          "Get email reports for your dashboards or metrics, and set up custom alerts to stay informed when your defined criteria are met",
        order: 10,
      },
    },
    {
      id: 10,
      attributes: {
        name: "Data Management",
        createdAt: "2023-03-20T10:06:29.927Z",
        updatedAt: "2023-03-20T14:59:23.144Z",
        publishedAt: "2023-03-20T10:06:31.009Z",
        description:
          "Plan for and manage your events and user properties, transfer data and configurations between Countly Servers, and filter unwanted data",
        order: 11,
      },
    },
    {
      id: 11,
      attributes: {
        name: "Compliance Management",
        createdAt: "2023-03-20T10:06:38.577Z",
        updatedAt: "2023-03-20T14:59:28.342Z",
        publishedAt: "2023-03-20T10:06:40.210Z",
        description:
          "Manage user consent and handle data subject requests to be compliant with regulations such as GDPR",
        order: 12,
      },
    },
    {
      id: 12,
      attributes: {
        name: "App and User Management",
        createdAt: "2023-03-20T10:06:47.700Z",
        updatedAt: "2023-03-20T14:59:33.643Z",
        publishedAt: "2023-03-20T10:06:48.758Z",
        description:
          "Set up multiple apps to track data and manage app/feature-level dashboard access with user groups and user management",
        order: 13,
      },
    },
    {
      id: 13,
      attributes: {
        name: "Security Management",
        createdAt: "2023-03-20T10:06:56.938Z",
        updatedAt: "2023-03-20T14:59:39.166Z",
        publishedAt: "2023-03-20T10:06:57.833Z",
        description:
          "Role-based user and group authorization, configurable security policies for passwords, HTTP headers, and rate limits, audit logs and two-factor authentication.",
        order: 14,
      },
    },
    {
      id: 14,
      attributes: {
        name: "User and Session Analytics",
        createdAt: "2023-03-20T10:08:24.777Z",
        updatedAt: "2023-03-20T14:58:25.570Z",
        publishedAt: "2023-03-20T10:08:26.174Z",
        description:
          "Track and visualize active users, user session activity, loyalty, acquisition sources, device info, location data, views, and heatmaps for clicks/scrolls (heatmaps are web only)",
        order: 1,
      },
    },
  ],
  PLUGIN_FEATURES_FALLBACK: [
    {
      id: 2,
      attributes: {
        featureID: "voice-customer",
        createdAt: "2023-03-15T21:06:04.464Z",
        updatedAt: "2023-03-16T14:28:11.235Z",
        publishedAt: "2023-03-15T21:06:17.122Z",
        locale: "en",
        description:
          "Collect feedback from the right users for a complete view of your user experience using surveys, NPS®, and ratings",
        name: "Voice of the Customer",
        arcadeEmbedURL: "https://demo.arcade.software/JQK0Nmdi0ARIgi0k7iKg?embed",
      },
    },
    {
      id: 3,
      attributes: {
        featureID: "formulas",
        createdAt: "2023-03-15T21:08:50.993Z",
        updatedAt: "2023-03-16T14:28:26.004Z",
        publishedAt: "2023-03-15T21:16:28.223Z",
        locale: "en",
        description:
          "Craft formulas with your existing data in Countly to reveal insights about your users and their behavioural patterns, elevating your understanding of their needs",
        name: "Formulas",
        arcadeEmbedURL: "https://demo.arcade.software/F34ma7amWt4WCxs2rDD8?embed",
      },
    },
    {
      id: 4,
      attributes: {
        featureID: "hooks",
        createdAt: "2023-03-15T21:22:41.640Z",
        updatedAt: "2023-03-16T14:28:37.266Z",
        publishedAt: "2023-03-15T21:22:43.015Z",
        locale: "en",
        description:
          "Trigger external endpoints and receive emails based on incoming data and internal triggers, such as users entering a cohort",
        name: "Hooks",
        arcadeEmbedURL: "https://demo.arcade.software/q5idm0f8TBRTWnPEJFXj?embed",
      },
    },
    {
      id: 5,
      attributes: {
        featureID: "dbviewer",
        createdAt: "2023-03-16T14:30:23.528Z",
        updatedAt: "2023-03-16T14:35:59.756Z",
        publishedAt: "2023-03-16T14:35:59.749Z",
        locale: "en",
        description:
          "Retrieve your raw data directly from the dashboard or through the API, perform queries across all data collections, and export data from your Countly server in the desired format",
        name: "Database Viewer",
        arcadeEmbedURL: "https://demo.arcade.software/ILdZpaJWbmKMytCXOdMT?embed",
      },
    },
    {
      id: 6,
      attributes: {
        featureID: "crashes",
        createdAt: "2023-03-16T14:40:06.602Z",
        updatedAt: "2023-03-16T14:40:08.010Z",
        publishedAt: "2023-03-16T14:40:07.999Z",
        locale: "en",
        description:
          "Collect crash reports, error logs, and performance metrics from your applications, allowing you to address issues proactively before they affect your users' experience",
        name: "Crash and Performance Analytics",
        arcadeEmbedURL: null,
      },
    },
    {
      id: 7,
      attributes: {
        featureID: "push",
        createdAt: "2023-03-16T14:43:30.172Z",
        updatedAt: "2023-03-16T14:43:31.400Z",
        publishedAt: "2023-03-16T14:43:31.394Z",
        locale: "en",
        description:
          "Deliver personalized one-time or automated push notifications to your mobile application users for enhanced engagement and communication",
        name: "Push Notifications",
        arcadeEmbedURL: "https://demo.arcade.software/smxfAs8hDGs7SC1eTRkh?embed",
      },
    },
    {
      id: 8,
      attributes: {
        featureID: "remote-ab",
        createdAt: "2023-03-16T15:34:18.952Z",
        updatedAt: "2023-03-16T15:34:21.367Z",
        publishedAt: "2023-03-16T15:34:21.358Z",
        locale: "en",
        description:
          "Adjust the appearance and functionality of your application remotely for specific user segments or all users, and run experiments to pinpoint the most effective improvements",
        name: "Remote Config and A/B Testing",
        arcadeEmbedURL: "https://demo.arcade.software/aQojAUcX8CVzZr58DS45?embed",
      },
    },
    {
      id: 9,
      attributes: {
        featureID: "okta-ad",
        createdAt: "2023-03-20T13:10:22.518Z",
        updatedAt: "2023-03-20T13:25:13.360Z",
        publishedAt: "2023-03-20T13:25:13.354Z",
        locale: "en",
        description:
          "Authorize and authenticate your dashboard users using Okta or Microsoft/Azure Active Directory",
        name: "Okta or Active Directory Auth",
        arcadeEmbedURL: null,
      },
    },
  ],
  WELCOME_FALLBACK: {
    id: 1,
    attributes: {
      createdAt: "2023-03-15T09:45:18.430Z",
      updatedAt: "2023-03-20T11:20:40.164Z",
      publishedAt: "2023-03-20T11:20:40.157Z",
      title: "Welcome to Countly Flex!",
      belowTitleText:
        "Great to have you here. We can't wait to see you create your first Countly Server in your desired location with the features you need.",
      linksText: "Some resources to get you started with ease:",
      linkOneText: "SDK Integration",
      linkOneURL:
        "https://support.count.ly/hc/en-us/articles/360037236571-Downloading-and-Installing-SDKs",
      linkTwoText: "User Guides",
      linkTwoURL:
        "https://support.count.ly/hc/en-us/sections/7039354168729-User-Guides-Countly-22-x",
      allowCallBooking: true,
      callBookingText: "Let's help you get started",
      callBookingURL: "https://calendly.com/mycountly/welcome",
      callBookingButtonText: "Book a 30 min call",
      arcadeEmbedURL: "https://demo.arcade.software/Flwo69SysOAHSSlYtOsE?embed",
      linkOneIcon: {
        data: {
          id: 2,
          attributes: {
            name: "welcome-sdks.svg",
            alternativeText: null,
            caption: null,
            width: 32,
            height: 32,
            formats: null,
            hash: "welcome_sdks_920adeba6c",
            ext: ".svg",
            mime: "image/svg+xml",
            size: 0.4,
            url: "/uploads/welcome_sdks_920adeba6c.svg",
            previewUrl: null,
            provider: "local",
            provider_metadata: null,
            createdAt: "2023-03-15T09:52:24.366Z",
            updatedAt: "2023-03-15T09:52:24.366Z",
          },
        },
      },
      linkTwoIcon: {
        data: {
          id: 1,
          attributes: {
            name: "welcome-guides.svg",
            alternativeText: null,
            caption: null,
            width: 32,
            height: 32,
            formats: null,
            hash: "welcome_guides_156b9c7548",
            ext: ".svg",
            mime: "image/svg+xml",
            size: 0.65,
            url: "/uploads/welcome_guides_156b9c7548.svg",
            previewUrl: null,
            provider: "local",
            provider_metadata: null,
            createdAt: "2023-03-15T09:52:24.363Z",
            updatedAt: "2023-03-15T09:52:24.363Z",
          },
        },
      },
    },
  },
  PRELOGIN_FALLBACK: {
    id: 1,
    attributes: {
      title: "Product analytics you can depend on",
      createdAt: "2023-03-20T15:22:17.036Z",
      updatedAt: "2023-03-20T16:52:47.721Z",
      publishedAt: "2023-03-20T15:22:19.472Z",
      subtitle:
        "Your very own product analytics server, ready in seconds. In the location you want, with the rich features you need.",
      brandsHeader: "Craft data-driven product experiences like them",
      brands: [
        {
          id: 1,
          name: "BMW",
          logo: {
            data: {
              id: 16,
              attributes: {
                name: "bmw@2x.svg",
                alternativeText: null,
                caption: null,
                width: 287,
                height: 287,
                formats: null,
                hash: "bmw_2x_ed1d111bde",
                ext: ".svg",
                mime: "image/svg+xml",
                size: 4.91,
                url: "/uploads/bmw_2x_ed1d111bde.svg",
                previewUrl: null,
                provider: "local",
                provider_metadata: null,
                createdAt: "2023-03-20T16:35:38.079Z",
                updatedAt: "2023-03-20T16:35:38.079Z",
              },
            },
          },
        },
        {
          id: 2,
          name: "AWS",
          logo: {
            data: {
              id: 15,
              attributes: {
                name: "aws@2x.svg",
                alternativeText: null,
                caption: null,
                width: 301,
                height: 180,
                formats: null,
                hash: "aws_2x_e91f810bd6",
                ext: ".svg",
                mime: "image/svg+xml",
                size: 6.54,
                url: "/uploads/aws_2x_e91f810bd6.svg",
                previewUrl: null,
                provider: "local",
                provider_metadata: null,
                createdAt: "2023-03-20T16:35:38.062Z",
                updatedAt: "2023-03-20T16:35:38.062Z",
              },
            },
          },
        },
        {
          id: 5,
          name: "Coca Cola",
          logo: {
            data: {
              id: 17,
              attributes: {
                name: "coke@2x.svg",
                alternativeText: null,
                caption: null,
                width: 671,
                height: 220,
                formats: null,
                hash: "coke_2x_c86062147c",
                ext: ".svg",
                mime: "image/svg+xml",
                size: 13.61,
                url: "/uploads/coke_2x_c86062147c.svg",
                previewUrl: null,
                provider: "local",
                provider_metadata: null,
                createdAt: "2023-03-20T16:35:38.087Z",
                updatedAt: "2023-03-20T16:35:38.087Z",
              },
            },
          },
        },
        {
          id: 6,
          name: "Verizon",
          logo: {
            data: {
              id: 13,
              attributes: {
                name: "verizon@2x.svg",
                alternativeText: null,
                caption: null,
                width: 658,
                height: 146,
                formats: null,
                hash: "verizon_2x_b0444e7495",
                ext: ".svg",
                mime: "image/svg+xml",
                size: 2.28,
                url: "/uploads/verizon_2x_b0444e7495.svg",
                previewUrl: null,
                provider: "local",
                provider_metadata: null,
                createdAt: "2023-03-20T16:35:37.852Z",
                updatedAt: "2023-03-20T16:35:37.852Z",
              },
            },
          },
        },
        {
          id: 7,
          name: "SAP",
          logo: {
            data: {
              id: 14,
              attributes: {
                name: "sap@2x.svg",
                alternativeText: null,
                caption: null,
                width: 455,
                height: 225,
                formats: null,
                hash: "sap_2x_37d84165d6",
                ext: ".svg",
                mime: "image/svg+xml",
                size: 2.22,
                url: "/uploads/sap_2x_37d84165d6.svg",
                previewUrl: null,
                provider: "local",
                provider_metadata: null,
                createdAt: "2023-03-20T16:35:37.869Z",
                updatedAt: "2023-03-20T16:35:37.869Z",
              },
            },
          },
        },
        {
          id: 8,
          name: "Wire",
          logo: {
            data: {
              id: 19,
              attributes: {
                name: "wire.svg",
                alternativeText: null,
                caption: null,
                width: 519,
                height: 163,
                formats: null,
                hash: "wire_1127acf747",
                ext: ".svg",
                mime: "image/svg+xml",
                size: 3.2,
                url: "/uploads/wire_1127acf747.svg",
                previewUrl: null,
                provider: "local",
                provider_metadata: null,
                createdAt: "2023-03-20T16:50:06.730Z",
                updatedAt: "2023-03-20T16:50:06.730Z",
              },
            },
          },
        },
      ],
    },
  },
};
